export const SETTING_COURSE_INDEX = 'SETTING_COURSE_INDEX';
export const SETTING_COURSE_LOADING = 'SETTING_COURSE_LOADING';
export const SETTING_COURSE_RESET = 'SETTING_COURSE_RESET';
